import { render, staticRenderFns } from "./GenericWordsForm.vue?vue&type=template&id=5f46bd1f&scoped=true&lang=pug&"
import script from "./GenericWordsForm.vue?vue&type=script&lang=js&"
export * from "./GenericWordsForm.vue?vue&type=script&lang=js&"
import style0 from "./GenericWordsForm.vue?vue&type=style&index=0&id=5f46bd1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f46bd1f",
  null
  
)

export default component.exports